//roles:["Admin","Developers","Support Admin","Support Manager","Sales"],

export const adminRoutes = [
  {
    path: "/",
    children: [
      {
        path: "/events/all",
        alias: "/",
        name: "Events",
        meta: {
          title: "Events",
          icon: "mdi-calendar",
          roles: ["Admin", "Manager"]
        },
      },
    ],
  },
  {
    path: "/organizers",
    alias: "/",
    name: "Organizers",
    meta: {
      title: "Organizers",
      roles: [
        "Admin"  
      ],
      icon: "mdi-account-multiple"
    }
  },
  {
    path: "/",
    alias: "/Reports",
    name: "Reports",
    meta: {
      title: "Reports",
      roles: [
        "Admin",
        "Manager",
      ],
      icon: "mdi-chart-timeline-variant-shimmer"
    },
    children: [
      {
        path: "/event-report",
        alias: "/",
        name: "Events Report",
        meta: {
          title: "EventReport",
          roles: [
            "Admin",
            "Manager",
          ],
          icon: "mdi-view-list"
        }
      }
    ]
  },
  {
    path: "/",
    alias: "/Administration",
    name: "Administration",
    meta: {
      title: "Administration",
      roles: [
        "Admin"
      ],
      icon: "mdi-account-cog"
    },
    children: [
      {
        path: "/usermanagement/list",
        alias: "/",
        name: "User Management",
        meta: {
          title: "UserManagement",
          roles: [
            "Admin"
          ],
          icon: "mdi-account-multiple"
        }
      },
      {
        path: "/administration/holidaycalendar",
        alias: "/",
        name: "Holiday Calendar",
        meta: {
          title: "HolidayCalendar",
          roles: [
            "Admin"
          ],
          icon: "mdi-calendar-month"
        }
      }
    ]
  },
  
];
export const hasAccess = {
  dashboard: {
    Sales: {
      environment: false,
      customerReports: true,
      internalReports: true,
      reportStats: true,
      reportAbug: true,
      reportRequest: true
    },
    "Support Manager": {
      customerReports: false,
      internalReports: true,
      ticketStats: true,
      reportStats: false,
      reportAbug: true,
      reportRequest: false
    }
  },
  viewReport: {
    "Support Admin": {
      updateStatus: false,
      editReport: true
    },
    Sales: {
      updateStatus: false,
      editReport: true
    }
  },
  accessNotes: ["Admin", "Developers"]
};
